import * as types from './types';
import axios from '../../utils/axios';
import * as END_POINTS from '../../utils/endpoints';
import Router from 'next/router';
import * as LocalStorage from '../../utils/localStorage';
import { openSnack } from './snackbarActions';
import Cookies from 'js-cookie';

const data = {
  api_key_val: 'rxaDWNmsctT69dcTBXMysRKuc6y5KmZbne2UzhZJQcR8KGHxxsdxVjpr',
};

export const setUserData = (payload) => ({
  type: types.SET_USER_DATA,
  payload,
});
export const setVerifyPhoneError = (payload) => ({
  type: types.SET_VERIFY_PHONE_ERROR,
  payload,
});
export const verifyPhoneRequest = () => ({
  type: types.VERIFY_PHONE_REQUEST,
});
export const verifyPhoneSuccess = () => ({
  type: types.VERIFY_PHONE_SUCCESS,
});

export const getCities = () => async (dispatch) => {
  try {
    dispatch({
      type: types.GET_CITIES_REQUEST,
    });
    const cities = await axios.post(END_POINTS.CITIES_LIST, data);

    dispatch({
      type: types.GET_CITIES_SUCCESS,
      payload: cities.data,
    });
  } catch (error) {
    console.log('=============errror=======================');
    console.log(error.response ?? error.message);
    console.log('====================================');
    dispatch({
      type: types.GET_CITIES_FAIL,
      error: error.response?.data?.message ?? error.message,
    });
  }
};

export const signUp = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: types.SIGN_UP_REQUEST,
    });

    const signUpRes = await axios.post(END_POINTS.SIGN_UP, {
      ...data,
      ...payload,
    });

    LocalStorage.setUserId(signUpRes.data?.user_id);
    Router.push({
      pathname: '/verify_phone',
    });
    dispatch({
      type: types.SIGN_UP_SUCCESS,
      payload: { ...payload, user_id: signUpRes.data?.user_id },
    });
    dispatch(
      openSnack({
        message: 'تم انشاء الحساب بنجاح',
        type: 'success',
      })
    );
  } catch (error) {
    console.log('=============errror=======================');
    console.log(error.response?.data?.message ?? error.message);
    console.log('====================================');
    dispatch({
      type: types.SIGN_UP_FAIL,
      error: error.response?.data?.message ?? error.message,
    });
    dispatch(
      openSnack({
        message: error.response?.data?.message ?? error.message,
        type: 'error',
      })
    );
  }
};

export const verifyPhone = (payload) => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.VERIFY_PHONE_REQUEST,
    });
    const AuthState = getState().auth;
    const phone = AuthState?.currentUser?.phone;
    const country_code = AuthState?.currentUser?.country_code;
    console.log('=============AuthState=======================');
    console.log(AuthState);
    console.log('====================================');
    const api_payload = {
      verification_code: payload,
      phone: `${country_code}${phone}`,
      country_code: country_code,
    };
    console.log('================api_payload====================');
    console.log(api_payload);
    console.log('====================================');

    const res = await axios.post(END_POINTS.LOGIN, api_payload);

    Router.push({
      pathname: '/',
    });
    dispatch({
      type: types.VERIFY_PHONE_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.log('=============errror==response=====================');
    console.log(error.response);
    console.log('====================================');

    dispatch({
      type: types.VERIFY_PHONE_FAIL,
      error:
        error.response?.message ??
        error.response?.data?.response?.msg ??
        error.message,
    });
    dispatch(
      openSnack({
        message: error.response?.data?.message ?? error.message,
        type: 'error',
      })
    );
  }
};

export const resendCode = (payload, secureHash) => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.RESEND_PHONE_REQUEST,
    });

    const authState = getState().auth;
    const country_code = authState.currentUser.country_code;
    const phone = authState.currentUser.phone;

    const api_payload = {
      country_code,
      phone,
      'g-token': payload.token,
      'g-token-checkbox': payload['g-token-checkbox'],
      'timestamp': payload.timestamp
    };

    const config = {
      headers: {
        'X-Secure-Hash': secureHash,
        'Content-Type': 'application/json'
      }
    };

    await axios.post(END_POINTS.SEND_CODE, {
      ...api_payload,
    }, config);

    dispatch({
      type: types.RESEND_PHONE_SUCCESS,
    });
  } catch (error) {
    console.log('=============errror=======================');
    console.log(error.response ?? error.message);
    console.log('====================================');

    dispatch({
      type: types.RESEND_PHONE_FAIL,
      error:
        error.response.message ??
        error.response?.data?.message ??
        error.message,
    });
  }
};

export const sendLoginCode = (payload, secureHash) => async (dispatch) => {
  try {
    dispatch({
      type: types.SEND_LOGIN_CODE_REQUEST,
    });

    const rToken = Cookies.get('rToken');

    const userData = JSON.parse(
      JSON.stringify({
        ...payload,
        isPhoneValid: undefined,
      })
    );

    const config = {
      headers: {
        'X-Secure-Hash': secureHash,
        'Content-Type': 'application/json'
      }
    };

    await axios.post(END_POINTS.SEND_CODE, {
      ...data,
      ...userData,
      referral_code: rToken,
    }, config);

    dispatch({
      type: types.SEND_LOGIN_CODE_SUCCESS,
      payload,
    });
  } catch (error) {
    dispatch({
      type: types.SEND_LOGIN_CODE_FAIL,
      error: error.response?.data?.message ?? error.message,
    });
  }
};

export const resetPhone = () => ({
  type: types.RESET_PHONE,
});

export const getCurrentUserInfo = () => async (dispatch) => {
  try {
    dispatch({
      type: types.GET_CURRENT_USER_REQUEST,
    });

    const userId = LocalStorage.getUserId();
    const token = LocalStorage.getToken();
    if (!token) return;
    const currentUserRes = await axios.post(
      END_POINTS.PERSONAL_INFO,
      { ...data, user_id: userId },
      {
        headers: { Authorization: 'Bearer ' + token },
      }
    );

    dispatch({
      type: types.GET_CURRENT_USER_SUCCESS,
      payload: currentUserRes.data,
    });

    dispatch(fetchUserData({ uuid: userId }));

    LocalStorage.setUserType(currentUserRes.data.data.user_type);
  } catch (error) {
    console.log('=============errror=======================');
    console.log(error.response ?? error.message);
    console.log('====================================');
    dispatch({
      type: types.GET_CURRENT_USER_FAIL,
      error: error.response?.data?.message ?? error.message,
    });
  }
};

export const completeProfile = (payload) => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.UPDATE_CURRENT_USER_REQUEST,
    });

    const res = await axios.post(END_POINTS.UPDATE_PERSONAL_INFO, payload);
    LocalStorage.setName(res.data?.data?.user.name);
    LocalStorage.setUserName(res.data?.data?.user.username);
    LocalStorage.setUserTypeIntercom(res.data?.data?.user.user_type);
    reRunIntercom();
    dispatch({
      type: types.UPDATE_CURRENT_USER_SUCCESS,
      payload: res.data?.data?.user ?? {},
    });
  } catch (error) {
    console.log('=============errror=======================');
    console.log(error.response);
    console.log('====================================');
    dispatch({
      type: types.UPDATE_CURRENT_USER_FAIL,
      error: error.response?.data?.message ?? error.message,
    });
  }
};

export const profileUpdate = (payload) => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.PROFILE_UPDATE_REQUEST,
    });

    const AuthState = getState().auth;
    const phone = AuthState.currentUser?.phone;
    const phone_code = AuthState.currentUser?.phone_code;
    const res = await axios.post(END_POINTS.PERSONAL_INFO_UPDATE, {
      ...data,
      ...payload,
      phone,
      phone_code,
    });
    dispatch({
      type: types.PROFILE_UPDATE_SUCCESS,
      payload: res.data?.data,
    });

    dispatch(
      openSnack({
        message: 'تم التحديث بنجاح',
        type: 'success',
      })
    );
  } catch (error) {
    console.log('=============errror=======================');
    console.log(error.response);
    console.log('====================================');
    dispatch({
      type: types.PROFILE_UPDATE_FAIL,
      error: error.response?.data?.message ?? error.message,
    });
    dispatch(
      openSnack({
        message: error.response?.data?.message ?? error.message,
        type: 'error',
      })
    );
  }
};

export const getTutorProfile = (payload) => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.GET_TUTOR_PROFILE_REQUEST,
    });

    const response = await axios.get(END_POINTS.TUTOR_PROFILE, {
      params: { slug: payload },
    });

    console.log('==========response==========================');
    console.log(response.data);
    console.log('====================================');
    dispatch({
      type: types.GET_TUTOR_PROFILE_SUCCESS,
      payload: response.data?.data,
    });
  } catch (error) {
    console.log('=============GET_TUTOR_PROFILE_FAIL=======================');
    console.log(error.response || error.message);
    console.log('====================================');

    dispatch({
      type: types.GET_TUTOR_PROFILE_FAIL,
      error: error.response?.data?.message ?? error.message,
    });
  }
};

export const clearMessages = (payload) => {
  return {
    type: types.CLEAR_ERROR,
  };
};

export const resetTutorProfile = (payload) => {
  return {
    type: types.RESET_TUTOR_PROFILE,
  };
};

export const setPrevPath = (payload) => {
  return {
    type: types.SET_PREV_PATH,
    payload,
  };
};
